'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.buildOrderedMessageMap = undefined;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _immutable = require('immutable');

var _buildPublishedMessage = require('../factories/PubNubMessageFactory/buildPublishedMessage');

var _buildMessageKey = require('../pubnub-message/operators/buildMessageKey');

var _PubNubMessageRecord = require('../pubnub-message/records/PubNubMessageRecord');

var _PubNubMessageRecord2 = _interopRequireDefault(_PubNubMessageRecord);

var _invariant = require('react-utils/invariant');

var _invariant2 = _interopRequireDefault(_invariant);

var _commentMessageToPubNubMessage = require('../pubnub-message/operators/commentMessageToPubNubMessage');

var _isThreadComment = require('../pubnub-message/operators/isThreadComment');

var _isCommonMessageFormat = require('../common-message-format/operators/isCommonMessageFormat');

var _buildCommonMessage = require('../common-message-format/operators/buildCommonMessage');

var _isCrmObjectLifecycleUpdate = require('../crm-object-lifecycle-update/operators/isCrmObjectLifecycleUpdate');

var _CrmObjectLifecycleUpdate = require('../crm-object-lifecycle-update/records/CrmObjectLifecycleUpdate');

var _CrmObjectLifecycleUpdate2 = _interopRequireDefault(_CrmObjectLifecycleUpdate);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Construct an OrderedMap<PubNubMessageKey, PubNubMessageModel> from Array<Message Objects>
 *
 * @param {Iterable} messages Message objects returned by the history API
 */
var buildOrderedMessageMap = exports.buildOrderedMessageMap = function buildOrderedMessageMap() {
  var messages = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

  (0, _invariant2.default)(_immutable.Iterable.isIterable(messages) || Array.isArray(messages), 'Expected messages to be iterable not a `%s`', typeof messages === 'undefined' ? 'undefined' : _typeof(messages));
  return messages.reduce(function (acc, messageObject) {
    var message = messageObject;

    if ((0, _isThreadComment.isThreadComment)(messageObject)) {
      message = (0, _buildPublishedMessage.buildPublishedMessage)((0, _commentMessageToPubNubMessage.commentMessageToPubNubMessage)(messageObject));
    } else if ((0, _isCommonMessageFormat.isCommonMessageFormat)(messageObject)) {
      message = (0, _buildCommonMessage.buildCommonMessage)(messageObject);
    } else if ((0, _isCrmObjectLifecycleUpdate.isCrmObjectLifecycleUpdate)(messageObject)) {
      message = new _CrmObjectLifecycleUpdate2.default(messageObject);
    } else if (!(messageObject instanceof _PubNubMessageRecord2.default)) {
      message = (0, _buildPublishedMessage.buildPublishedMessage)(messageObject);
    }
    return acc.set((0, _buildMessageKey.buildMessageKey)(message), message);
  }, (0, _immutable.OrderedMap)());
};


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/conversations-schema/static-2.2846/js/thread-history/buildOrderedMessageMap.js
// module id = 745
// module chunks = 2 3